<div class="elementCont" id="textboxcont-{{indexofelement}}">

  <div class="heading-container">
    <div id="heading-{{indexofelement}}" class="heading-custom-form overflowWrapAnywhere" #headingInp>{{heading}}</div>
    <div id="subheading-{{indexofelement}}" class="subheading-custom-form overflowWrapAnywhere" #subheadingInp>{{subHeading}} </div>
  </div>
  
</div>
